import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopFiltersWrapper = styled.div`
  display: flex;
`;

export const FilterList = styled.div`
  font-size: 14px;
  margin-right: 20px;

  .dropdown {
    flex-direction: row;
    justify-content: space-between;
    width: 300px;

    @media (min-width: 1421px) {
        width: 350px;
    }

    @media (min-width: 1521px) {
        width: 400px;
    }

    div[class*="Menu"]:nth-of-type(2) {
        box-shadow: none !important;
        outline: 1px solid #c2c2c2;
        margin-top: 5px;
        
        ul {
            border: none;
        }

        button {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 2;
            line-height: 1.5;
            max-height: calc(1.9em * 2);
            border-top: none;
            border-left: none;
            border-right: none;
            border-bottom: 1px solid #c2c2c2;

            &:hover {
                background-color: #dbe3e9;
            }
        }
    }
  }
`;

export const AlignmentPdfWrapper = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  background: none;
  color: inherit;
  border: none;
  padding: 10px 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  
  div:first-child {
    margin-right: 5px;
    display: flex;
    align-items: center;
    width: 10px;
  }
`;

export const AlignmentPdfText = styled.p`
  font-size: 12px;
  color: #415667;
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./components/course-filters/styled.js